// Deep links de la app. Puros (leen y escriben strings), sin efectos secundarios: el consumidor
// decide qué hacer con el resultado.

import type { LatLng } from "./geo";
import type { LineId } from "./data";

// `?lines=K1,K2,L`. Devuelve la lista en el orden en que apareció (sin duplicados) o null si el
// parámetro no está o queda vacío tras limpiar. NO valida contra el catálogo de líneas: eso lo
// hace el consumidor cuando ya tiene el dataset cargado.
export function parseLinesParam(query: string): LineId[] | null {
  const params = new URLSearchParams(query);
  const raw = params.get("lines");
  if (raw === null) return null;
  const seen = new Set<string>();
  const out: string[] = [];
  for (const tok of raw.split(",")) {
    const t = tok.trim();
    if (!t || seen.has(t)) continue;
    seen.add(t);
    out.push(t);
  }
  return out.length > 0 ? out : null;
}

// `?from=lat,lon` (o `?to=lat,lon`). Coordenadas en decimal, punto como separador. Coordenadas
// fuera de rango o mal formadas → null (no lanzamos).
export function parsePointParam(query: string, key: "from" | "to"): LatLng | null {
  const raw = new URLSearchParams(query).get(key);
  if (raw === null) return null;
  const parts = raw.split(",").map((s) => Number(s.trim()));
  if (parts.length !== 2) return null;
  const [lat, lon] = parts as [number, number];
  if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;
  if (lat < -90 || lat > 90 || lon < -180 || lon > 180) return null;
  return { lat, lon };
}

// Serializa a `lat,lon` con 5 decimales (~1 m de precisión) para poner en la URL.
export function formatPointParam(ll: LatLng): string {
  return `${ll.lat.toFixed(5)},${ll.lon.toFixed(5)}`;
}
